<div class="panel measure-histograms-panel" *ngIf="selectedMeasure && localState">
  <gpf-role-selector
    (updateSelectedRoles)="replaceSelectedRoles($event)"
    [initialState]="localState.roles"></gpf-role-selector>
  <div>
    <div class="measure-histograms-container">
      <div class="title-wrapper"
        >{{ selectedMeasure.measure }}
        <button
          *ngIf="selectedMeasure.description"
          id="measure-description-button"
          [ngbTooltip]="selectedMeasure.description"
          [autoClose]="true"
          triggers="manual"
          #t="ngbTooltip"
          (click)="t.open()">
          <span class="material-symbols-outlined" id="measure-description-icon">info</span>
        </button>
      </div>

      <div *ngIf="isCategoricalHistogram(selectedMeasure.histogram)">
        <button mat-icon-button [matMenuTriggerFor]="menu" id="view-menu-button">
          <span>Mode</span>
        </button>
        <mat-menu #menu="matMenu">
          <button
            mat-menu-item
            (click)="switchCategoricalHistogramView('range selector')"
            [ngClass]="{ 'selected-view': localState.categoricalView === 'range selector' }"
            >range selector
          </button>
          <button
            mat-menu-item
            (click)="switchCategoricalHistogramView('click selector')"
            [ngClass]="{ 'selected-view': localState.categoricalView === 'click selector' }"
            >click selector
          </button>
          <button
            mat-menu-item
            (click)="switchCategoricalHistogramView('dropdown selector')"
            [ngClass]="{ 'selected-view': localState.categoricalView === 'dropdown selector' }"
            >dropdown selector
          </button>
        </mat-menu>
      </div>
    </div>

    <div
      *ngIf="
        selectedMeasure &&
        isCategoricalHistogram(selectedMeasure.histogram) &&
        localState.categoricalView === 'dropdown selector'
      "
      style="width: 100%">
      <gpf-categorical-values-dropdown
        [initialState]="localState.values"
        [histogram]="selectedMeasure.histogram"
        (updateSelectedValues)="replaceCategoricalValues($event)"
        (emitValidationErrors)="setHistogramValidationErrors($event)"></gpf-categorical-values-dropdown>
    </div>

    <div *ngIf="localState.categoricalView !== 'dropdown selector'" class="col-sm-11">
      <gpf-histogram
        *ngIf="selectedMeasure && isNumberHistogram(selectedMeasure.histogram)"
        [width]="800"
        [height]="145"
        [marginLeft]="180"
        [bins]="selectedMeasure.histogram.bins"
        [bars]="selectedMeasure.histogram.bars"
        [logScaleX]="selectedMeasure.histogram.logScaleX"
        [logScaleY]="selectedMeasure.histogram.logScaleY"
        [smallValuesDesc]="selectedMeasure.histogram.smallValuesDesc"
        [largeValuesDesc]="selectedMeasure.histogram.largeValuesDesc"
        [rangeStart]="localState.rangeStart"
        (rangeStartChange)="updateRangeStart($event)"
        [rangeEnd]="localState.rangeEnd"
        (rangeEndChange)="updateRangeEnd($event)"
        style="display: block; margin-top: 17px"
        (emitValidationErrors)="setHistogramValidationErrors($event)">
      </gpf-histogram>
      <gpf-categorical-histogram
        *ngIf="
          selectedMeasure &&
          isCategoricalHistogram(selectedMeasure.histogram) &&
          localState.categoricalView === 'click selector'
        "
        [width]="600"
        [height]="145"
        [histogram]="selectedMeasure.histogram"
        [initialSelectedValueNames]="localState.values"
        [interactType]="localState.categoricalView"
        (selectCategoricalValues)="replaceCategoricalValues($event)"
        (emitValidationErrors)="setHistogramValidationErrors($event)">
      </gpf-categorical-histogram>
      <gpf-categorical-histogram
        *ngIf="
          selectedMeasure &&
          isCategoricalHistogram(selectedMeasure.histogram) &&
          localState.categoricalView === 'range selector'
        "
        [width]="600"
        [height]="145"
        [histogram]="selectedMeasure.histogram"
        [initialSelectedValueNames]="localState.values"
        [interactType]="localState.categoricalView"
        (selectCategoricalValues)="replaceCategoricalValues($event)"
        (emitValidationErrors)="setHistogramValidationErrors($event)">
      </gpf-categorical-histogram>
    </div>

    <div class="col-sm-11">
      <gpf-errors-alert [errors]="errors"></gpf-errors-alert>
    </div>
  </div>
</div>
